import { type ReactNode } from "react";

export type TimelineEvent = {
  at: string;
  title: string;
  body?: ReactNode;
  tone?: "neutral" | "accent" | "good" | "warn" | "bad";
};

const DOT = {
  neutral: "bg-line border-ink-soft/30",
  accent: "bg-accent/30 border-accent",
  good: "bg-good/30 border-good",
  warn: "bg-warn/30 border-warn",
  bad: "bg-bad/30 border-bad",
} as const;

export function Timeline({ events }: { events: ReadonlyArray<TimelineEvent> }) {
  if (events.length === 0) {
    return (
      <div className="rounded-xl border border-line bg-canvas-2 p-10 text-center text-ink-soft text-sm">
        No events yet.
      </div>
    );
  }
  return (
    <ol className="rounded-xl border border-line bg-canvas-2 p-5 space-y-4">
      {events.map((e, i) => (
        <li key={i} className="grid grid-cols-[auto_1fr] gap-3">
          <div className="flex flex-col items-center pt-1">
            <span
              className={`w-3 h-3 rounded-full border-2 ${DOT[e.tone ?? "neutral"]}`}
            />
            {i < events.length - 1 && <span className="w-px flex-1 bg-line mt-1" />}
          </div>
          <div className="pb-2">
            <div className="flex items-baseline justify-between gap-3">
              <h4 className="text-sm font-medium text-ink">{e.title}</h4>
              <time className="text-xs text-ink-soft shrink-0">{e.at}</time>
            </div>
            {e.body && (
              <div className="mt-1 text-sm text-ink-soft">{e.body}</div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
